module.exports = __webpack_public_path__ + "static/media/retail-property-grid-4.84d7b39e.jpeg";